import { useEffect, useState } from 'react';

/** Phones and small tablets in portrait: below Tailwind's `md` breakpoint. */
export const MOBILE_QUERY = '(max-width: 767px)';

/** True while the viewport is phone-sized; updates on resize and rotation. */
export function useIsMobile(): boolean {
  const [mobile, setMobile] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(MOBILE_QUERY).matches,
  );
  useEffect(() => {
    const mq = window.matchMedia(MOBILE_QUERY);
    const update = () => setMobile(mq.matches);
    update();
    mq.addEventListener('change', update);
    return () => mq.removeEventListener('change', update);
  }, []);
  return mobile;
}
